import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Global from '../../store/global-selectors';
import { CurrencyService } from '../../services/currency-service';

const mapStateToProps = (state, props) => {
  const sellerDefaultCurrencyCode = Global.selectSellerDefaultCurrency(state);
  const { currencyCode } = props;
  return {
    currencyCode,
    sellerDefaultCurrencyCode,
  };
};

export const CurrencySymbolContainer = connect(mapStateToProps)(({ currencyCode, sellerDefaultCurrencyCode }) => {
  const intl = useIntl();
  return CurrencyService.getSymbolFromCode(currencyCode, sellerDefaultCurrencyCode, intl.locale).symbol;
});
